import type { RouteObject } from "react-router-dom";
import { CouponsPage } from "@/modules/coupons/pages/CouponsPage";
import { DiscountsPage } from "@/modules/coupons/pages/DiscountsPage";

export const couponsRoutes: RouteObject[] = [
  {
    path: "coupons",
    element: <CouponsPage />,
  },
];

export const discountsRoutes: RouteObject[] = [
  {
    path: "discounts",
    element: <DiscountsPage />,
  },
];
